import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IUserSelectorBuilder from "../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";

const meses = {
  1: "Enero",
  2: "Febrero",
  3: "Marzo",
  4: "Abril",
  5: "Mayo",
  6: "Junio",
  7: "Julio",
  8: "Agosto",
  9: "Septiembre",
  10: "Octubre",
  11: "Noviembre",
  12: "Diciembre"
};

const mesesOpts = [];
for (const key in meses) {
  mesesOpts.push({
    label: meses[key],
    value: key
  });
}

const currentYear = new Date().getFullYear();
const aniosOpts = [{ label: currentYear - 1, value: currentYear - 1 }];

export type Inputs =
  | "tipoBusqueda"
  | "mes"
  | "anio"
  | "tipoComision"
  | "idAsesor"
  | "folioFactura";

export type Buttons = "buscar";

const hiddenIfFactura = values => values.tipoBusqueda === "factura";
const hiddenIfNotPeriodo = values => !!values.tipoBusqueda;
const hiddenIfNotAsesor = values => values.tipoBusqueda !== "asesor";
const hiddenIfNotFactura = values => values.tipoBusqueda !== "factura";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "tipoBusqueda",
      label: "Tipo de Búsqueda",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Por Periodo",
        data: [
          { value: "asesor", label: "Por Asesor" },
          { value: "factura", label: "Por Factura" }
        ]
      }
    },
    {
      name: "mes",
      label: "* Mes",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: mesesOpts,
        hidden: hiddenIfFactura
      }
    },
    {
      name: "anio",
      label: "Año",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: currentYear.toString(),
        data: aniosOpts,
        hidden: hiddenIfFactura
      }
    },
    {
      name: "tipoComision",
      label: "Tipo de Comisión",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        data: [
          { value: "Membresia", label: "Membresía" },
          { value: "Anualidad", label: "Anualidad" }
        ],
        hidden: hiddenIfNotPeriodo
      }
    },
    {
      name: "idAsesor",
      label: "Asesor",
      bts: { mCol: 4 },
      component: IUserSelectorBuilder,
      props: {
        hidden: hiddenIfNotAsesor
      }
    },
    {
      name: "folioFactura",
      label: "Folio Factura",
      bts: { mCol: 2 },
      component: ITextBuilder,
      props: {
        hidden: hiddenIfNotFactura
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 2 },
      component: IButtonBuilder
    }
  ],
  validations: {
    mes: {
      requiredIfNotFactura: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda !== "factura" && !value,
        message: () => "Campo obligatorio"
      }
    }
  },
  rows: [
    [
      "tipoBusqueda",
      "mes",
      "anio",
      "tipoComision",
      "idAsesor",
      "folioFactura",
      "buscar"
    ]
  ]
};
